import React, { useState } from "react";
import {
  MenuItem,
  Select,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";

export function EditableSelectCell({
  value = "",
  options = [],
  onChange = () => {},

  // ✅ new props
  enableAddNew = false,
  addNewLabel = "Add new...",
  addNewTitle = "Add new option",
  onAddNew = () => {}, // (newValue: string) => void

  ...restProps
}) {
  const [openAdd, setOpenAdd] = useState(false);
  const [newVal, setNewVal] = useState("");

  const safeOptions = Array.isArray(options) ? options : [];
  const ADD_KEY = "__ADD_NEW__";

  const handleSelect = (val) => {
    if (enableAddNew && val === ADD_KEY) {
      setNewVal("");
      setOpenAdd(true);
      return;
    }
    onChange(val);
  };

  const handleSave = () => {
    const v = String(newVal ?? "").trim();
    if (!v) return;
    onAddNew(v); // parent will push into options + select it
    setOpenAdd(false);
  };

  return (
    <>
      <Select
        value={safeOptions?.length ? (value ?? "") : ""}
        fullWidth
        disableUnderline
        variant="standard"
        sx={{
          bgcolor: "transparent",
          "& .MuiSelect-select": {
            whiteSpace: "pre-wrap",
            overflowWrap: "anywhere",
            wordBreak: "break-word",
            hyphens: "auto",
            fontSize: "0.65rem",
          },
        }}
        onChange={(e) => handleSelect(e.target.value)}
        MenuProps={{
          PaperProps: {
            style: { maxHeight: 400, overflowY: "auto" },
          },
          MenuListProps: { style: { maxHeight: 400 } },
        }}
        {...restProps}
      >
        {safeOptions.map((option, index) => (
          <MenuItem key={index} value={option}>
            {option}
          </MenuItem>
        ))}

        {enableAddNew && (
          <MenuItem value={ADD_KEY} sx={{ fontStyle: "italic" }}>
            ➕ {addNewLabel}
          </MenuItem>
        )}
      </Select>

      <Dialog open={openAdd} onClose={() => setOpenAdd(false)} fullWidth>
        <DialogTitle>{addNewTitle}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            fullWidth
            label="New value"
            value={newVal}
            onChange={(e) => setNewVal(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleSave();
              }
            }}
            sx={{ mt: 1 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenAdd(false)}>Cancel</Button>
          <Button
            variant="contained"
            onClick={handleSave}
            disabled={!String(newVal).trim()}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
